export const DATA_TABLES_EVENTS = {
  COPY_TO_CLIPBOARD: 'copyToClipboard',
  PRINT_DATA_TABLE: 'printDataTable',
  DOWNLOAD_DATA_TABLE: 'downloadDataTable',
  DOWNLOAD_DATA_TABLE_AS_CSV: 'downloadDataTableAsCSV',
  DOWNLOAD_DATA_TABLE_AS_XLSX: 'downloadDataTableAsXLSX',
};

export const SORT_DIRECTION_KEYS = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SORT_DIRECTION_LABELS_LEGACY = {
  [SORT_DIRECTION_KEYS.ASC]: 'up',
  [SORT_DIRECTION_KEYS.DESC]: 'down',
};

export const SORT_DIRECTIONS_LEGACY = {
  [SORT_DIRECTION_KEYS.ASC]: SORT_DIRECTION_LABELS_LEGACY.ASC,
  [SORT_DIRECTION_KEYS.DESC]: SORT_DIRECTION_LABELS_LEGACY.DESC,
};

export const SORT_BY_DEFAULT = 'id';
